// extracted by mini-css-extract-plugin
export var banner = "_gu-0";
export var closeButton = "_gu-2";
export var greenCheckmark = "_gu-3";
export var hereLink = "_gu-4";
export var titleIcon = "_gu-1";